<!-- Back to top button -->
<div class="back-to-top"></div>

<header>
    <nav class="navbar navbar-expand-lg navbar-light bg-white sticky" data-offset="1">
        <div class="container">
            <div>
                <a href="#" class="navbar-brand">
                    <img src="assets/img/logo1.png" alt="NuvertOS" style="height: 50px; cursor: pointer;">
                    <!-- <img src="assets/img/Nuvertos logo low.png" alt="NuvertOS" style="height: 50px; cursor: pointer;"> -->
                </a>
            </div>

            <div>
                <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span class="navbar-toggler-icon"></span>
                </button>
            </div>

            <div class="navbar-collapse collapse" id="navbarContent">
                <ul class="navbar-nav ml-auto mr-auto">
                    <li class="nav-item " [routerLinkActive]="['active'] " [routerLinkActiveOptions]="{exact: true} ">
                        <a class="nav-link " [routerLink]="['product/usp']" (click)="collapseNav()">Our Products</a>
                        <a class="nav-link " [routerLink]="['product/journey']" (click)="collapseNav()" style="display:none">Journey</a>
                        <a class="nav-link " [routerLink]="['product/list']" (click)="collapseNav()" style="display:none">List</a>
                    </li>

                    <div class="dropdown show" (mouseenter)="showMenuOnHover()" (mouseleave)="hideMenuOnLeave()">
                        <li class="nav-item " [routerLinkActive]="['active'] " [routerLinkActiveOptions]="{exact: true} ">

                            <span class="nav-link " href="javascript:void(0);" id="dropdownMenuLinkCompany" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Company</span>
                            <div class="dropdown-arrow"></div>

                            <div class="dropdown-menu custom-dropdown" id="companyDropdown" aria-labelledby="dropdownMenuLinkCompany">
                                <a class="dropdown-item" routerLink="/about-us" (click)="collapseNav()">
                                    <div class="menu-icon">
                                        <img src="assets/img/about_US.svg" alt="">
                                    </div>
                                    <div class="menu-text">
                                        About Us
                                    </div>
                                </a>
                                <a class="dropdown-item" routerLink="/board" (click)="collapseNav()">
                                    <div class="menu-icon">
                                        <img src="assets/img/board.svg" alt="">
                                    </div>
                                    <div class="menu-text">
                                        Our Board
                                    </div>
                                </a>
                            </div>
                        </li>
                    </div>
                    <li class="nav-item " routerLinkActive="active ">
                        <a class="nav-link " routerLink="/careers"(click)="collapseNav()">Careers</a>
                    </li>
                    <li class="nav-item " [routerLinkActive]="['active'] ">
                        <a class="nav-link " routerLink="/contact-us" (click)="collapseNav()">Contact Us</a>
                    </li>
                </ul>
                <span class="nav-item ">
                <button class="btn brand-button ml-lg-2 navbar-demo-button" (click)="openDemo()">Demo</button>

                    <button class="btn brand-button-outline ml-lg-2 " data-toggle="collapse" data-target="#navbarContent" (click)="openLogin()">Login</button>
                </span>
            </div>

        </div>
    </nav>
</header>

<app-login></app-login>
<app-demo></app-demo>